import { useCallback, useContext, useEffect, useState } from "react";

import {
  Context,
  createCareerChallengeTopics,
  fetchCareerChallengeSheet,
  clearCareerChallengeSheetId,
  clearSuccessMessage,
  clearErrorMessage,
  CREATE_CAREER_CHALLENGE_TOPICS_SUCCESS_MESSAGE,
  CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE,
} from "../store/student";

import { useWaitApiCall } from "./useWaitApiCall";

const useCareerChallengeTopics = (isChallengeSheetOpen: boolean) => {
  const { contextState, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(contextState);
  const [isCreateTopicsFailed, setIsCreateTopicsFailed] = useState(false);
  const [pendingChallengeSheetId, setPendingChallengeSheetId] = useState(0);

  useEffect(() => {
    if (!isChallengeSheetOpen || !contextState.career_challenge_sheet_id)
      return;
    setPendingChallengeSheetId(contextState.career_challenge_sheet_id);
    dispatch(fetchCareerChallengeSheet());
    dispatch(clearCareerChallengeSheetId());
  }, [isChallengeSheetOpen, contextState.career_challenge_sheet_id, dispatch]);

  useEffect(() => {
    if (
      !pendingChallengeSheetId ||
      contextState.career_challenge_sheet?.id !== pendingChallengeSheetId
    )
      return;
    dispatch(peep(createCareerChallengeTopics(pendingChallengeSheetId)));
    setPendingChallengeSheetId(0);
  }, [
    pendingChallengeSheetId,
    contextState.career_challenge_sheet?.id,
    dispatch,
    peep,
  ]);

  useEffect(() => {
    if (
      contextState.success_message !==
      CREATE_CAREER_CHALLENGE_TOPICS_SUCCESS_MESSAGE
    )
      return;
    dispatch(clearSuccessMessage());
    setIsCreateTopicsFailed(false);
  }, [contextState.success_message, dispatch]);

  useEffect(() => {
    if (contextState.error !== CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE)
      return;
    dispatch(clearErrorMessage());
    setIsCreateTopicsFailed(true);
  }, [contextState.error, dispatch]);

  const createTopics = useCallback(
    (id: number) => {
      dispatch(peep(createCareerChallengeTopics(id)));
    },
    [dispatch, peep],
  );

  return { calling, isCreateTopicsFailed, createTopics };
};

export default useCareerChallengeTopics;
